export const trialFeatures = {
  osPatchManagement: {
    featureCode: 'osPatchManagement',
    productCode: 'PATCH-2021',
  },

  zeroTrust: {
    featureCode: 'zeroTrust',
    productCode: 'PLATFORM-PLUS-2021',
  },

  deviceManagement: {
    featureCode: 'deviceManagement',
    productCode: 'POLICY-DEVICES',
  },

  passwordManagement: {
    featureCode: 'passwordManagement',
    productCode: 'PASSWORD-MGMT',
  },

  cloudInsights: {
    featureCode: 'cloudInsights',
    productCode: 'CLOUD-INSIGHTS',
  },
};

export const UpgradePageCardsData = [
  {
    title: 'Patch Management',
    planDescription:
      'JumpCloud’s automated patch management helps you secure your fleet to remotely manage, schedule, install OS and browser updates for your macOS, Windows, and Ubuntu devices.',
    rateType: 'user',
    featureCode: 'osPatchManagement',
    upgradeType: 'Add On',
    upgradeTypeText:
      'Explore features individually with Add Ons. Find more on our ',
    planComponents: [
      {
        name: 'OS Patching',
        features: ['Mac', 'Linux Ubuntu', 'Windows'],
      },
      {
        name: 'Browser Patching',
        features: ['Chrome'],
      },
      {
        name: 'Coming Soon',
        features: ['Third-party Application Patching', 'Edge', 'Firefox'],
      },
    ],
    order: 1,
    badgeTextBase: 'You have been trying Patch Management for',
    featureLink: 'configurationsMainPanelOsPatchMgmt',
    productCode: trialFeatures.osPatchManagement.productCode,
  },

  {
    title: 'Platform Plus',
    planDescription:
      'Implement a Zero Trust security model to secure user access to devices, applications, files, networks, and other resources from a single cloud directory platform.',
    rateType: 'user',
    featureCode: 'zeroTrust',
    includedFeatureText: 'Everything in Platform, plus:',
    upgradeType: 'Package',
    upgradeTypeText: 'To learn more about other plans see our ',
    upgradeFeatureText: 'Everything in Platform, plus:',
    planComponents: [
      {
        name: 'Zero Trust',
        features: [
          'Conditional Access Policies',
          'Device Trust',
          'Network Trust',
        ],
      },
      {
        name: 'Premium Support',
        features: [
          '24x7 support & implementation support with guaranteed uptime SLA',
        ],
      },
    ],
    order: 2,
    badgeTextBase: 'You have been trying Conditional Access Policies for',
    featureLink: 'authNPoliciesMainPanel',
    productCode: trialFeatures.zeroTrust.productCode,
  },

  {
    title: 'Password Manager',
    featureFlag: 'passwordManagerTrial',
    planDescription:
      'The JumpCloud Password Manager™ enables your team to securely manage and share passwords, two-factor authentication (2FA), and other types of sensitive information while providing you with full visibility and control over passwords used across your organization.',
    rateType: 'user',
    featureCode: 'passwordManagement',
    upgradeType: 'Add On',
    planComponents: [
      {
        name: '',
        features: [
          'Decentralized storage architecture',
          'Auto-fill passwords and 2FA',
          'Securely share passwords and 2FA',
        ],
      },
      {
        name: '',
        features: [
          'Generate strong passwords',
          'Administrative controls and reporting',
        ],
      },
    ],
    order: 3,
    badgeTextBase: 'You have been trying Password Manager for',
    productCode: trialFeatures.passwordManagement.productCode,
    featureLink: 'passwordManager',
  },

  {
    title: 'Cloud Insights',
    featureFlag: 'cloudInsightsTrial',
    planDescription:
      'With Cloud Insights, your team can monitor user actions, identify high risk events, and prepare compliance reports for your AWS environment through an intuitive and frictionless interface.',
    rateType: 'Cloud Platform User',
    featureCode: 'cloudInsights',
    upgradeType: 'Add On',
    upgradeTypeText:
      'Explore features individually with Add Ons. Find more on our',
    planComponents: [
      {
        name: 'Current',
        features: [
          'AWS management events fired',
          'Connector-based tagging',
          'Non-person entity event filtering',
        ],
      },
      {
        name: 'Coming Soon',
        features: [
          'Alert and criticality tagging',
          'Identity and other data enrichments',
        ],
      },
    ],
    order: 4,
    badgeTextBase: 'You have been trying Cloud Insights for',
    featureLink: 'CloudInsightsMain',
    productCode: trialFeatures.cloudInsights.productCode,
  },
];

export const accountEmail = 'accounts@jumpcloud.com';

export const trialModalLinks = {
  fairUsePolicy: {
    url: 'https://jumpcloud.com/fair-use-policy',
    text: 'fair use policy',
  },
  account: {
    url: '#/account/general',
    text: 'See More.',
  },
  pricing: {
    externalLink: 'https://jumpcloud.com/pricing',
    text: 'See More.',
  },
  salesContact: {
    url: `mailto:${accountEmail}`,
    text: 'Reach out to us',
  },
  stopATrial: {
    url:
      'https://jumpcloud-support.force.com/support/s/article/Start-or-Stop-a-Trial',
    text: 'Stop a Trial',
  },
};

/**
 * TODO: Store this within a single variable.
 */
export const FeatureTrialTextConsts = {
  zeroTrust: {
    featureCode: 'zeroTrust',
    featureTitle: 'Conditional Access Policies',
    featureDescription:
      "Use Conditional Access Policies to implement Zero Trust security in your organization. You can create conditional access policies that secure access to resources based on conditions like a user's identity and the network and device they’re on.",
    featureTrialEndingInstruction:
      'To end your trial of Conditional Access Policies, delete or disable any policies using conditions, or remove conditions from those policies.',
    includedFeatures: ['Device Trust', 'Network Trust', 'Geolocation Trust', 'Disk Encryption'],
    kbArticle:
      'https://support.jumpcloud.com/s/article/Getting-Started-Conditional-Access-Policies',
  },

  osPatchManagement: {
    featureCode: 'osPatchManagement',
    featureTitle: 'Patch Management',
    featureDescription:
      'Easily create schedules and manage device patching from a single console, achieve greater visibility and reporting for OS, browser, and application version control, and strengthen device security posture while meeting organizational compliance needs.',
    featureTrialEndingInstruction:
      'To end your trial of Patch Management, delete all of your Patch Management policies.',
    includedFeatures: ['OS Patching', 'Browser Patching'],
  },

  patchManagement: {
    featureCode: 'osPatchManagement',
    featureTitle: 'Patch Management',
    featureDescription:
      'Easily create schedules and manage device patching from a single console, achieve greater visibility and reporting for OS, browser, and application version control, and strengthen device security posture while meeting organizational compliance needs.',
    featureTrialEndingInstruction:
      'To end your trial of Patch Management, delete all of your Patch Management policies.',
    includedFeatures: ['OS Patching', 'Browser Patching'],
  },

  cloudInsights: {
    featureCode: 'cloudInsights',
    featureTitle: 'Cloud Insights',
    featureDescription:
      'With Cloud Insights, your team can monitor user actions, identify high risk events, and prepare compliance reports for your AWS environment through an intuitive and frictionless interface.',
    featureTrialEndingInstruction:
      'To end your trial of Cloud Insights, delete all of your Cloud Insights accounts.',
    priceBasis: 'cloud platform user',
    includedFeatures: [
      'AWS management events fired',
      'Connector-based tagging',
      'Non-person entity event filtering',
    ],
  },

  passwordManagement: {
    featureCode: 'passwordManagement',
    featureTitle: 'Password Manager',
    featureDescription:
      'The JumpCloud Password Manager™ enables your team to securely manage and share passwords, two-factor authentication (2FA), and other types of sensitive information while providing you with full visibility and control over passwords used across your organization.',
    featureTrialEndingInstruction:
      'To end your trial of Password Manager, remove all of your enrolled user groups.',
    includedFeatures: [
      'Decentralized storage architecture',
      'Auto-fill passwords and 2FA',
      'Securely share passwords and 2FA',
      'Generate strong passwords',
      'Administrative controls and reporting',
    ],
  },
};

export const trialPropsData = {
  zeroTrust: {
    featurePackageMarkdown: 'Platform*Plus*',
    eventLocation: 'Conditional Policies Trial Modal',
    featureCode: 'zeroTrust',
    copyKey: 'zeroTrust',
    featureName: 'Conditional Access Policies',
    featurePackage: 'Platform Plus',
    subHeaderText: FeatureTrialTextConsts.zeroTrust.featureDescription,
    productCode: 'PLATFORM-PLUS-2021',
    kbArticle:
      'https://support.jumpcloud.com/s/article/Getting-Started-Conditional-Access-Policies',
  },

  osPatchManagement: {
    eventLocation: 'Patch Management Trial Modal',
    featureCode: 'osPatchManagement',
    copyKey: 'osPatchManagement',
    featureName: 'Patch Management',
    featurePackage: 'Patch Management',
    subHeaderText: FeatureTrialTextConsts.osPatchManagement.featureDescription,
    isAddOn: true,
    productCode: trialFeatures.osPatchManagement.productCode,
    kbArticle:
      'https://support.jumpcloud.com/s/article/Getting-Started-Patch-Management',
  },

  patchManagement: {
    eventLocation: 'Patch Management Trial Modal',
    featureCode: 'osPatchManagement',
    copyKey: 'patchManagement',
    featureName: 'Patch Management',
    featurePackage: 'Patch Management',
    subHeaderText: FeatureTrialTextConsts.osPatchManagement.featureDescription,
    isAddOn: true,
    productCode: trialFeatures.osPatchManagement.productCode,
    kbArticle:
      'https://jumpcloud-support.force.com/support/s/article/Browser-Patch-Policy',
  },

  cloudInsights: {
    eventLocation: 'Cloud Insights Trial Modal',
    featureCode: 'cloudInsights',
    featureName: 'Cloud Insights',
    featurePackage: 'Cloud Insights',
    subHeaderText: FeatureTrialTextConsts.cloudInsights.featureDescription,
    isAddOn: true,
    productCode: trialFeatures.cloudInsights.productCode,
    kbArticle:
      'https://support.jumpcloud.com/s/article/Getting-Started-Cloud-Insights',
  },

  passwordManagement: {
    eventLocation: 'Password Manager Trial Modal',
    featureCode: 'passwordManagement',
    featureName: 'Password Manager',
    featurePackage: 'Password Manager',
    subHeaderText: FeatureTrialTextConsts.passwordManagement.featureDescription,
    isAddOn: true,
    productCode: trialFeatures.passwordManagement.productCode,
    kbArticle:
      'https://support.jumpcloud.com/s/article/Getting-Started-JumpCloud-Password-Manager',
  },
};

export const ContactModalBody = 'Our Annual and A La Carte plans are customizable. Get in touch with one of our account managers for help with your purchase today at 1-855-212-3122.';

export const FeatureIllustrationUrl = 'https://s3.amazonaws.com/static.jumpcloud.com/adminportal/trial';

export default {
  UpgradePageCardsData,
};
